
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/[state]/[city]",
      function () {
        return require("private-next-pages/locations/[state]/[city]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations/[state]/[city]"])
      });
    }
  